import { c } from 'ttag';

import {
    APP_UPSELL_REF_PATH,
    MAIL_UPSELL_PATHS,
    PROTON_SENTINEL_NAME,
    UPSELL_COMPONENT,
} from '@proton/shared/lib/constants';
import { getUpsellRef } from '@proton/shared/lib/helpers/ref';
import shieldImg from '@proton/styles/assets/img/illustrations/new-upsells-img/shield.svg';

import type { ModalStateProps } from '../../../../../modalTwo/useModalState';
import UpsellModal from '../../../../../upsell/UpsellModal/UpsellModal';

interface Props {
    modalProps: ModalStateProps;
    upsellComponent?: UPSELL_COMPONENT;
}

const ProtonSentinelUpsellModal = ({ modalProps, upsellComponent }: Props) => (
    <UpsellModal
        data-testid="security-center:proton-sentinel:upsell-modal"
        title={c('Title').t`High security for your account`}
        description={c('Description')
            .t`${PROTON_SENTINEL_NAME} protects your account with dedicated 24/7 monitoring of suspicious activity — including escalation to security specialists.`}
        modalProps={modalProps}
        illustration={shieldImg}
        upsellRef={getUpsellRef({
            app: APP_UPSELL_REF_PATH.MAIL_UPSELL_REF_PATH,
            component: upsellComponent || UPSELL_COMPONENT.MODAL,
            feature: MAIL_UPSELL_PATHS.PROTON_SENTINEL,
        })}
    />
);

export default ProtonSentinelUpsellModal;
